import { render, staticRenderFns } from "./TheLoginButton.vue?vue&type=template&id=d5981162&"
import script from "./TheLoginButton.vue?vue&type=script&lang=js&"
export * from "./TheLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports